module.exports = __webpack_public_path__ + "static/media/purpleTheme-girl.e0b48a21.svg";